export default "__VITE_ASSET__9mWMEHYI__"